// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.v-menu__content[data-v-801d3550] {\n    width: 100% !important;\n    max-width: 100% !important;\n}\n#language[data-v-801d3550] {\n    width: 20% !important;\n    left: 1px !important;\n    max-width: 100% !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
